export default {
  props: {
    marketplaceUser: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
